// src/components/Selfie.js
import { useEffect, useRef } from "react";
import incode from "../services/incode"; // Asegúrate de que la ruta sea correcta

const Selfie = ({ session, assistedOb, onSuccess, onError }) => {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }

    console.log("Valor de assistedOb recibido en Selfie:", assistedOb); // <-- Aquí el log

    incode.renderCamera("selfie", containerRef.current, {
      onSuccess,
      onError: onError,
      token: session, // Usa session.token
      numberOfTries: 3,
      showTutorial: true,
      showCustomCameraPermissionScreen: true,
      showDoublePermissionsRequest: true,
      assistedOnboarding:assistedOb
    });
    isMounted.current = true;
  }, [onSuccess, onError, session, assistedOb]);

  return <div ref={containerRef}></div>;
};

export default Selfie;
